import React from "react";
import axios from "axios";
import { Checkbox, Divider, message, Drawer, InputNumber, Row } from "antd";
import { useState, useEffect } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

import { BETA_FEATURES } from "../../constants/betaFeatures";

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext"; 

const CheckboxGroup = Checkbox.Group;
const betaFeatureOptions = Object.values(BETA_FEATURES).map(feature => feature.label);

const UserBetaFeatures = ({ userId, betaFeatures, dhlCodLimit }) => {
  const { permissions } = usePermissions();
  
  const [checkedList, setCheckedList] = useState(betaFeatures);
  const [codLimit, setCodLimit] = useState(dhlCodLimit);
  const [checkAll, setCheckAll] = useState(
    betaFeatures.length === betaFeatureOptions.length
  );
  const [disabled, setDisabled] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);

  useEffect(() => {
    setDisabled(!permissions?.includes(PERMISSIONS.UPDATE_BETA_FEATURES));
  }, [permissions]);

  const onChange = async (list) => {
    setCheckedList(list);
    setCheckAll(list.length === betaFeatureOptions.length);

    const wasPreviouslyChecked = checkedList.includes("DHL_COD_LIMIT");
    const isNowChecked = list.includes("DHL_COD_LIMIT");

    let limitToSave;
    if (!wasPreviouslyChecked && isNowChecked) {
      limitToSave = 2000;
      setCodLimit(2000);
    } else if (wasPreviouslyChecked && !isNowChecked) {
      limitToSave = null;
      setCodLimit(null);
    } else {
      limitToSave = isNowChecked ? codLimit : null;
    }

    try {
      await axios.put(`/api/user/${userId}/beta-features`, {
        betaFeatures: list,
        dhlCodLimit: limitToSave,
      });

      message.info("Updated");
    } catch (err) {
      message.error("Error when updating User Beta features.");
    }
  };
  const onCheckAllChange = async (e) => {
    const list = e.target.checked ? betaFeatureOptions : [];
    setCheckedList(list);
    setCheckAll(e.target.checked);

    const limitToSave = e.target.checked ? 2000 : null;

    try {
      await axios.put(`/api/user/${userId}/beta-features`, {
        betaFeatures: list,
        dhlCodLimit: limitToSave,
      });

      message.info("Updated");
    } catch (err) {
      message.error("Error when updating User Beta features.");
    }
  };

  const label = `${checkAll ? "Enable All" : "Disable All"}`;
  return (
    <>
      <React.Fragment>
        Description <InfoCircleOutlined onClick={() => setDrawerVisible(true)} />
        <Drawer
          title="Features"
          placement="right"
          onClose={() => setDrawerVisible(false)}
          visible={drawerVisible}
          width={736}
        >
          {Object.values(BETA_FEATURES).map(feature => (
            <div className="mb-2">
              <strong>{feature.label}</strong>
              <br />
              {feature.desc}
            </div>
          ))}
        </Drawer>
      </React.Fragment>

      <Divider />
      <Checkbox
        checked={checkAll}
        disabled={disabled}
        onChange={onCheckAllChange}
      >
        {label}
      </Checkbox>
      <Divider />
      <CheckboxGroup
        options={betaFeatureOptions}
        value={checkedList}
        onChange={onChange}
        disabled={disabled}
      />
      {checkedList.includes("DHL_COD_LIMIT") && (
        <Row style={{ marginTop: 16 }} align="middle" >
          <label>DHL COD Limit (RM):</label>
          <InputNumber
            min={0}
            value={codLimit}
            onChange={(value) => setCodLimit(value)}
            disabled={disabled}
            style={{ width: 200, marginLeft: 12 }}
            onBlur={() => {
              if (codLimit !== dhlCodLimit) {
                onChange(checkedList);
              }
            }}
          />
        </Row>
      )}
    </>
  );
};

export default UserBetaFeatures;
